import { Box } from '@mui/material';

import PremiumFeatureMessage from '@/components/UpgradeToPremium/PremiumFeatureMessage';
import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';

const BasicUserView = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center',
      gap: '16px',
      paddingTop: '48px'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: '62px',
        '& > *': {
          fontSize: '16px',
          fontWeight: 600
        }
      }}
    >
      <PremiumFeatureMessage />
    </Box>
    <UpgradeToPremiumButton type='upgrade' />
  </Box>
);

export default BasicUserView;
